/*
==============================================================================
Código hecho por Rcrea
Archivo: assets/section-rcrea-guten-product-hero.js
Sección: Enterprise | Main product
Versión: V9 - scroll desbloqueado
==============================================================================
*/
(() => {
  const ROOT_SELECTOR = '[data-rcrea-product-hero]';
  const INIT_ATTR = 'data-rcrea-product-hero-initialized';
  const DESKTOP_BREAKPOINT = 1024;

  const getRoots = (scope = document) => {
    const roots = [];

    if (scope.matches?.(ROOT_SELECTOR)) {
      roots.push(scope);
    }

    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => {
      roots.push(root);
    });

    return roots;
  };

  const isVisible = (element) => {
    if (!element) return false;

    const styles = window.getComputedStyle(element);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      Number(styles.opacity || 1) > 0 &&
      element.getClientRects().length > 0
    );
  };

  const readCssNumber = (element, property, fallback = 0) => {
    const value = Number.parseFloat(
      window
        .getComputedStyle(element)
        .getPropertyValue(property)
        .trim()
    );

    return Number.isFinite(value) ? value : fallback;
  };

  const setImportant = (element, property, value) => {
    element?.style.setProperty(property, value, 'important');
  };

  const hasMeaningfulPrice = (element) => {
    if (!isVisible(element)) return false;

    const value = String(element.textContent || '')
      .replace(/\s+/g, '')
      .replace(/[^\d]/g, '');

    return value.length > 0 && Number(value) > 0;
  };

  const updateProductState = (root) => {
    const priceRoot =
      root.querySelector('[data-rcrea-price-root]') ||
      root.querySelector('.product-info__price');

    const comparePrices = priceRoot
      ? Array.from(
          priceRoot.querySelectorAll(
            [
              's',
              'del',
              '.price__was',
              '.price-item--regular:not(:only-child)',
              '[class*="compare"]'
            ].join(',')
          )
        )
      : [];

    root.classList.toggle(
      'has-sale-price',
      comparePrices.some(hasMeaningfulPrice)
    );

    const addButton = root.querySelector(
      [
        '.js-product-form-main button[name="add"]',
        '.product-info__add-button button[name="add"]'
      ].join(',')
    );

    const soldOut = Boolean(
      addButton &&
        (
          addButton.disabled ||
          addButton.hasAttribute('disabled') ||
          addButton.getAttribute('aria-disabled') === 'true'
        )
    );

    root.classList.toggle('is-sold-out', soldOut);

    const variantInput = root.querySelector(
      [
        '.js-product-form-main input[name="id"]',
        '.js-product-form input[name="id"]'
      ].join(',')
    );

    if (variantInput?.value) {
      root.dataset.rcreaVariantId = variantInput.value;
    } else {
      delete root.dataset.rcreaVariantId;
    }
  };

  const clearForcedSquare = (root) => {
    root
      .querySelectorAll('[data-rph-square-forced]')
      .forEach((element) => {
        [
          'width',
          'min-width',
          'max-width',
          'height',
          'min-height',
          'max-height',
          'flex-basis',
          'aspect-ratio',
          'padding-top',
          'padding-bottom',
          'object-fit',
          'object-position',
          'border-radius'
        ].forEach((property) => {
          element.style.removeProperty(property);
        });

        element.removeAttribute('data-rph-square-forced');
      });
  };

  const markAndSet = (element, styles) => {
    if (!element) return;

    element.setAttribute(
      'data-rph-square-forced',
      'true'
    );

    Object.entries(styles).forEach(
      ([property, value]) => {
        setImportant(element, property, value);
      }
    );
  };

  const forceSquareGallery = (root, squareSize) => {
    const gallery = root.querySelector(
      '.rcrea-product-hero__gallery'
    );

    if (
      !gallery ||
      !Number.isFinite(squareSize) ||
      squareSize <= 0
    ) {
      return;
    }

    const size = `${Math.floor(squareSize)}px`;

    gallery
      .querySelectorAll(
        '.media-gallery__main,.media-gallery__viewer'
      )
      .forEach((element) => {
        if (!isVisible(element)) return;

        markAndSet(element, {
          width: size,
          'min-width': '0px',
          'max-width': size,
          height: size,
          'min-height': size,
          'max-height': size,
          'flex-basis': size,
          'aspect-ratio': '1 / 1',
          'border-radius': '22px'
        });
      });

    gallery
      .querySelectorAll(
        '.media-gallery__item,.media-viewer > ul > li'
      )
      .forEach((element) => {
        markAndSet(element, {
          width: '100%',
          'max-width': '100%',
          height: size,
          'min-height': size,
          'max-height': size,
          'aspect-ratio': '1 / 1',
          'border-radius': '22px'
        });
      });

    gallery
      .querySelectorAll(
        [
          '.media-gallery__main .media',
          '.media-gallery__viewer .media',
          '.media-gallery__main .media__wrapper',
          '.media-gallery__viewer .media__wrapper'
        ].join(',')
      )
      .forEach((element) => {
        markAndSet(element, {
          width: '100%',
          height: '100%',
          'min-height': '100%',
          'max-height': '100%',
          'padding-top': '0px',
          'padding-bottom': '0px',
          'aspect-ratio': '1 / 1',
          'border-radius': '22px'
        });
      });

    gallery
      .querySelectorAll(
        [
          '.media-gallery__main img',
          '.media-gallery__viewer img',
          '.media-gallery__main video',
          '.media-gallery__viewer video',
          '.media-gallery__main model-viewer',
          '.media-gallery__viewer model-viewer',
          '.media-gallery__main iframe',
          '.media-gallery__viewer iframe'
        ].join(',')
      )
      .forEach((element) => {
        markAndSet(element, {
          width: '100%',
          height: '100%',
          'max-width': '100%',
          'max-height': '100%',
          'object-fit': 'contain',
          'object-position': 'center',
          'border-radius': '22px'
        });
      });
  };

  const getVisibleThumbs = (gallery) => {
    return (
      Array.from(
        gallery.querySelectorAll(
          [
            '.media-gallery__thumbs',
            '[class*="media-gallery__thumbs"]'
          ].join(',')
        )
      ).find(isVisible) || null
    );
  };

  const getOuterHeight = (element) => {
    if (!isVisible(element)) return 0;

    const styles = window.getComputedStyle(element);

    return (
      element.getBoundingClientRect().height +
      (Number.parseFloat(styles.marginTop) || 0) +
      (Number.parseFloat(styles.marginBottom) || 0)
    );
  };

  const hideGalleryCounter = (root) => {
    root
      .querySelectorAll(
        [
          '.media-ctrl__counter',
          '.media-gallery__counter',
          '.media-gallery__count',
          '[class*="media-ctrl__counter"]',
          '[data-media-count]',
          '[data-slide-count]'
        ].join(',')
      )
      .forEach((counter) => {
        counter.hidden = true;
        counter.setAttribute('aria-hidden', 'true');
      });
  };

  const syncGalleryMetrics = (root) => {
    const gallery = root.querySelector(
      '.rcrea-product-hero__gallery'
    );

    hideGalleryCounter(root);

    if (
      !gallery ||
      window.innerWidth < DESKTOP_BREAKPOINT
    ) {
      root.style.removeProperty(
        '--rph-gallery-fixed-height'
      );

      root.style.removeProperty(
        '--rph-gallery-main-size'
      );

      root.style.removeProperty(
        '--rph-gallery-viewport-height'
      );

      clearForcedSquare(root);
      return;
    }

    const configuredHeight = readCssNumber(
      root,
      '--rph-gallery-min-height-d',
      700
    );

    const stickyOffset = readCssNumber(
      root,
      '--rph-sticky-offset-d',
      120
    );

    /*
     * Se calcula una altura grande una sola vez al cargar
     * o al cambiar el tamaño del navegador.
     *
     * Nunca se recalcula durante el scroll ni al usar flechas.
     */
    const viewportHeight = Math.max(
      700,
      Math.min(
        820,
        window.innerHeight -
          stickyOffset -
          18
      )
    );

    const fixedHeight = Math.max(
      configuredHeight,
      viewportHeight
    );

    root.style.setProperty(
      '--rph-gallery-fixed-height',
      `${Math.floor(fixedHeight)}px`
    );

    const galleryStyles =
      window.getComputedStyle(gallery);

    const paddingX =
      (Number.parseFloat(
        galleryStyles.paddingLeft
      ) || 0) +
      (Number.parseFloat(
        galleryStyles.paddingRight
      ) || 0);

    const paddingY =
      (Number.parseFloat(
        galleryStyles.paddingTop
      ) || 0) +
      (Number.parseFloat(
        galleryStyles.paddingBottom
      ) || 0);

    const contentWidth = Math.max(
      0,
      gallery.clientWidth - paddingX
    );

    const contentHeight = Math.max(
      0,
      fixedHeight - paddingY
    );

    const thumbsHeight = getOuterHeight(
      getVisibleThumbs(gallery)
    );

    const availableMainHeight = Math.max(
      240,
      contentHeight - thumbsHeight
    );

    const squareSize = Math.max(
      240,
      Math.min(
        contentWidth,
        availableMainHeight
      )
    );

    root.style.setProperty(
      '--rph-gallery-main-size',
      `${Math.floor(squareSize)}px`
    );

    forceSquareGallery(root, squareSize);
    hideGalleryCounter(root);
  };

  const createRafScheduler = (callback) => {
    let frame = null;

    const schedule = () => {
      if (frame) return;

      frame = window.requestAnimationFrame(() => {
        frame = null;
        callback();
      });
    };

    schedule.cancel = () => {
      if (!frame) return;

      window.cancelAnimationFrame(frame);
      frame = null;
    };

    return schedule;
  };

  const initGalleryMetrics = (root) => {
    const schedule = createRafScheduler(() => {
      syncGalleryMetrics(root);
    });

    schedule();
    window.setTimeout(schedule, 120);
    window.setTimeout(schedule, 480);
    window.setTimeout(schedule, 900);

    window.addEventListener(
      'resize',
      schedule,
      { passive: true }
    );

    window.addEventListener(
      'orientationchange',
      schedule,
      { passive: true }
    );

    window.addEventListener(
      'load',
      schedule,
      { once: true }
    );

    root._rphGalleryCleanup = () => {
      schedule.cancel();

      window.removeEventListener(
        'resize',
        schedule
      );

      window.removeEventListener(
        'orientationchange',
        schedule
      );

      root.style.removeProperty(
        '--rph-gallery-fixed-height'
      );

      root.style.removeProperty(
        '--rph-gallery-main-size'
      );

      root.style.removeProperty(
        '--rph-gallery-viewport-height'
      );

      clearForcedSquare(root);
    };
  };

  const initStateSync = (root) => {
    const schedule = createRafScheduler(() => {
      updateProductState(root);
      hideGalleryCounter(root);
    });

    const productInfo =
      root.querySelector(
        '.rcrea-product-hero__info'
      ) || root;

    let observer = null;

    const handleChange = (event) => {
      if (
        event.target?.matches?.(
          [
            'input[name="id"]',
            'select',
            'input[type="radio"]',
            'input[type="checkbox"]'
          ].join(',')
        )
      ) {
        schedule();
      }
    };

    root.addEventListener(
      'change',
      handleChange
    );

    if ('MutationObserver' in window) {
      observer = new MutationObserver(
        schedule
      );

      observer.observe(productInfo, {
        attributes: true,
        attributeFilter: [
          'class',
          'disabled',
          'aria-disabled',
          'hidden',
          'style',
          'value'
        ],
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    root._rphStateCleanup = () => {
      schedule.cancel();
      observer?.disconnect();

      root.removeEventListener(
        'change',
        handleChange
      );
    };
  };

  const initScrollState = (root) => {
    const schedule = createRafScheduler(() => {
      root.classList.toggle(
        'is-scrolled',
        root.getBoundingClientRect().top < -24
      );
    });

    schedule();

    window.addEventListener(
      'scroll',
      schedule,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      schedule,
      { passive: true }
    );

    root._rphScrollCleanup = () => {
      schedule.cancel();

      window.removeEventListener(
        'scroll',
        schedule
      );

      window.removeEventListener(
        'resize',
        schedule
      );
    };
  };

  const initFocusState = (root) => {
    const selector = [
      '.rcrea-product-hero__gallery',
      '.product-info__sticky',
      '.rcrea-product-hero__info'
    ].join(',');

    const handleFocusIn = (event) => {
      event.target
        .closest?.(selector)
        ?.classList.add('has-focus-within');
    };

    const handleFocusOut = (event) => {
      const card =
        event.target.closest?.(selector);

      if (!card) return;

      window.requestAnimationFrame(() => {
        if (
          !card.contains(
            document.activeElement
          )
        ) {
          card.classList.remove(
            'has-focus-within'
          );
        }
      });
    };

    root.addEventListener(
      'focusin',
      handleFocusIn
    );

    root.addEventListener(
      'focusout',
      handleFocusOut
    );

    root._rphFocusCleanup = () => {
      root.removeEventListener(
        'focusin',
        handleFocusIn
      );

      root.removeEventListener(
        'focusout',
        handleFocusOut
      );
    };
  };


  const initGalleryNavigationSync = (root) => {
    const galleries = Array.from(
      root.querySelectorAll(
        '.rcrea-product-hero__gallery media-gallery, .rcrea-product-hero__gallery .media-gallery'
      )
    );

    const cleanups = [];

    galleries.forEach((gallery) => {
      if (!gallery || gallery.dataset.rphSafeNavInitialized === 'true') return;

      const viewer = gallery.querySelector('.media-viewer, #gallery-viewer');

      if (!viewer) return;

      gallery.dataset.rphSafeNavInitialized = 'true';

      const prevButton = gallery.querySelector('.media-ctrl__btn[name="prev"], button[name="prev"]');
      const nextButton = gallery.querySelector('.media-ctrl__btn[name="next"], button[name="next"]');
      let frame = null;
      let activeIndex = 0;
      let isProgrammaticScroll = false;
      let programmaticTimer = null;

      const getItems = () => {
        return Array.from(viewer.children).filter((item) => {
          if (!item || item.nodeType !== 1) return false;
          const style = window.getComputedStyle(item);
          return style.display !== 'none' && item.offsetWidth > 0;
        });
      };

      const getItemLeft = (item, items) => {
        if (!item || !items.length) return 0;
        return item.offsetLeft - items[0].offsetLeft;
      };

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const setButtonState = (button, disabled) => {
        if (!button) return;

        if (disabled) {
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('disabled');
          button.setAttribute('aria-disabled', 'false');
        }
      };

      const centerThumbHorizontally = (thumbButton) => {
        const thumbsTrack = thumbButton?.closest?.('.media-thumbs');
        if (!thumbsTrack) return;

        const trackRect = thumbsTrack.getBoundingClientRect();
        const thumbRect = thumbButton.getBoundingClientRect();
        const delta =
          thumbRect.left -
          trackRect.left -
          (trackRect.width / 2) +
          (thumbRect.width / 2);

        thumbsTrack.scrollTo({
          left: thumbsTrack.scrollLeft + delta,
          behavior: 'smooth'
        });
      };

      const syncThumbs = (index, shouldCenterThumb = false) => {
        const items = getItems();
        const currentItem = items[index] || items[0];
        const currentMediaId = currentItem?.dataset?.mediaId;

        if (!currentMediaId) return;

        gallery.querySelectorAll('.media-thumbs__item').forEach((thumbItem) => {
          const isActive = thumbItem.dataset.mediaId === currentMediaId;
          const thumbButton = thumbItem.querySelector('.media-thumbs__btn, button, a');

          thumbItem.classList.toggle('is-active', isActive);

          if (thumbButton) {
            thumbButton.classList.toggle('is-active', isActive);

            if (isActive) {
              thumbButton.setAttribute('aria-current', 'true');

              /*
               * No usamos scrollIntoView aquí porque también mueve el scroll vertical
               * de la página. Ese era el choque que trababa el scroll al subir/bajar.
               * Solo centramos horizontalmente el thumbnail cuando el usuario hace click
               * en flechas o miniaturas.
               */
              if (shouldCenterThumb) {
                centerThumbHorizontally(thumbButton);
              }
            } else {
              thumbButton.removeAttribute('aria-current');
            }
          }
        });
      };

      const sync = (shouldCenterThumb = false) => {
        const items = getItems();

        if (!items.length) return;

        const currentScroll = viewer.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          const distance = Math.abs(getItemLeft(item, items) - currentScroll);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        activeIndex = closestIndex;
        syncThumbs(activeIndex, shouldCenterThumb);

        setButtonState(prevButton, activeIndex <= 0);
        setButtonState(nextButton, activeIndex >= items.length - 1);

        const counter = gallery.querySelector('.media-ctrl__current-item');
        if (counter) counter.textContent = String(activeIndex + 1);
      };

      const scheduleSync = (shouldCenterThumb = false) => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = null;
          sync(shouldCenterThumb);
        });
      };

      const releaseProgrammaticScroll = () => {
        window.clearTimeout(programmaticTimer);
        programmaticTimer = window.setTimeout(() => {
          isProgrammaticScroll = false;
          scheduleSync(false);
        }, 360);
      };

      const goTo = (targetIndex, behavior = 'smooth') => {
        const items = getItems();

        if (!items.length) return;

        const nextIndex = clamp(targetIndex, 0, items.length - 1);
        const item = items[nextIndex];
        const left = getItemLeft(item, items);

        activeIndex = nextIndex;
        syncThumbs(activeIndex, true);
        setButtonState(prevButton, activeIndex <= 0);
        setButtonState(nextButton, activeIndex >= items.length - 1);

        isProgrammaticScroll = true;

        viewer.scrollTo({
          left,
          behavior
        });

        releaseProgrammaticScroll();
        window.setTimeout(() => scheduleSync(false), 120);
        window.setTimeout(() => scheduleSync(false), 420);
      };

      const handleClick = (event) => {
        const controlButton = event.target.closest?.('.media-ctrl__btn, button[name="prev"], button[name="next"]');
        const thumbButton = event.target.closest?.('.media-thumbs__btn, .media-thumbs button');

        if (controlButton && gallery.contains(controlButton)) {
          const name = controlButton.getAttribute('name');
          if (name !== 'prev' && name !== 'next') return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();

          sync(false);
          goTo(name === 'next' ? activeIndex + 1 : activeIndex - 1);
          return;
        }

        if (thumbButton && gallery.contains(thumbButton)) {
          const thumbItem = thumbButton.closest('.media-thumbs__item');
          const mediaId = thumbItem?.dataset?.mediaId;
          const items = getItems();
          const index = items.findIndex((item) => item.dataset.mediaId === mediaId);

          if (index < 0) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();

          goTo(index);
        }
      };

      const handleViewerScroll = () => {
        if (isProgrammaticScroll) {
          releaseProgrammaticScroll();
        }

        scheduleSync(false);
      };

      viewer.addEventListener('scroll', handleViewerScroll, { passive: true });
      gallery.addEventListener('click', handleClick, true);
      window.addEventListener('resize', scheduleSync, { passive: true });
      window.addEventListener('orientationchange', scheduleSync, { passive: true });

      /*
       * Importante: no usamos MutationObserver sobre class/style.
       * El observer anterior reaccionaba a nuestras propias clases/aria-current,
       * creando un loop que podía pelear con el scroll nativo de la página.
       */
      scheduleSync(false);
      window.setTimeout(() => scheduleSync(false), 150);
      window.setTimeout(() => scheduleSync(false), 600);

      cleanups.push(() => {
        if (frame) {
          window.cancelAnimationFrame(frame);
          frame = null;
        }

        window.clearTimeout(programmaticTimer);
        viewer.removeEventListener('scroll', handleViewerScroll);
        gallery.removeEventListener('click', handleClick, true);
        window.removeEventListener('resize', scheduleSync);
        window.removeEventListener('orientationchange', scheduleSync);
        delete gallery.dataset.rphSafeNavInitialized;
      });
    });

    root._rphGalleryNavCleanup = () => {
      cleanups.forEach((cleanup) => cleanup());
      cleanups.length = 0;
    };
  };

  const initRoot = (root) => {
    if (
      !root ||
      root.hasAttribute(INIT_ATTR)
    ) {
      return;
    }

    root.setAttribute(
      INIT_ATTR,
      'true'
    );

    updateProductState(root);
    hideGalleryCounter(root);
    initStateSync(root);
    initScrollState(root);
    initGalleryMetrics(root);
    initFocusState(root);
    initGalleryNavigationSync(root);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        root.classList.add('is-ready');
      });
    });
  };

  const destroyRoot = (root) => {
    if (!root) return;

    root._rphStateCleanup?.();
    root._rphScrollCleanup?.();
    root._rphGalleryCleanup?.();
    root._rphFocusCleanup?.();
    root._rphGalleryNavCleanup?.();

    delete root._rphStateCleanup;
    delete root._rphScrollCleanup;
    delete root._rphGalleryCleanup;
    delete root._rphFocusCleanup;
    delete root._rphGalleryNavCleanup;

    root.classList.remove(
      'is-ready',
      'is-scrolled',
      'has-sale-price',
      'is-sold-out'
    );

    root.removeAttribute(INIT_ATTR);
  };

  const initAll = (scope = document) => {
    getRoots(scope).forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(),
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      getRoots(event.target).forEach(
        destroyRoot
      );
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const root =
        event.target.closest?.(
          ROOT_SELECTOR
        );

      if (!root) return;

      event.target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      updateProductState(root);
      syncGalleryMetrics(root);
    }
  );
})();